import src from "IMAGE";
export default { src, width: 1440, height: 425, blurWidth: 0, blurHeight: 0};
